<sol-dialog [dialog]="dialog$()" (action)="onAction($event)">
  <sol-layout px="16" py="16" gap="16">
    <sol-form [form]="form$()" (form)="onFormChange($event)" #formRef />
  </sol-layout>
</sol-dialog>
